import { z } from 'zod';
import { toast } from 'react-toastify';
import React from 'react';
import { LiliToast } from '@lili/lili-frontend-common';
import { useFormHook } from '../../../hooks/providers/useFormHooks';
import { useMutateTempPassword } from './useMutateTempPassword';
import useStore from '../../../store';
import { LOGIN_NAVIGATION_MAP } from '../components/LoginNavigation/constants';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';

export const useTempPasswordLogic = () => {
  const { mutateAsync: postTempPassword, isLoading } = useMutateTempPassword();
  const user = useStore((state) => state.user);
  const setCurrentPage = useStore((state) => state.setCurrentPage);

  const { formMethods } = useFormHook({
    formSchema: z.object({
      mainPassword: z.string()
        .trim()
        .min(8)
        .max(20),
      secondaryPassword: z.string()
        .trim(),
    }).superRefine((data, ctx) => {
      if (data.mainPassword !== data.secondaryPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['secondaryPassword'],
          message: 'Passwords do not match',
        });
      }
    }),
    formDefaultValues: { mainPassword: '', secondaryPassword: '' },
    schemaTitle: 'TempPassword',
  });

  const handleTempPasswordSuccess = async () => {
    setCurrentPage(LOGIN_NAVIGATION_MAP.WELCOME);
    toast(
      <LiliToast id='' text='Please login to your account again, using your new password' showCloseButton={false} />,
      {
        ...LiliToastDefaultConfig,
        autoClose: 5000,
        position: toast.POSITION.TOP_CENTER,
      },
    );
  };

  const handleSubmit = async () => {
    await postTempPassword({ userData: user, oldPassword: user.initialPassword || '', newPassword: formMethods.getValues().mainPassword });
    await handleTempPasswordSuccess();
  };

  return { formMethods, handleSubmit, isLoading };
};
